import type { PaymentIncidentsTranslations } from "../interfaces/paymentIncidents";

export const paymentIncidentsTranslations: PaymentIncidentsTranslations = {
  provider_fallback: "o provedor",
  organization_unknown: "Organização",
  action_cancel: "Cancelar",
  action_close: "Fechar",
  action_back: "Voltar",
  action_retry: "Tentar novamente",
  status_pending_report: "Não reportada",
  status_reported: "Reportada a {{provider}}",
  status_in_progress: "Em gestão com {{provider}}",
  status_provider_refunded: "{{provider}} devolveu",
  status_resolved: "Encerrada",
  status_dismissed: "Descartada",
  type_credit_not_applied: "Crédito não aplicado",
  type_credit_not_applied_hint:
    "{{provider}} o dá como concluído, mas o comércio ou a pessoa não recebeu o dinheiro.",
  type_status_not_updated: "Status sem atualização",
  type_status_not_updated_hint:
    "Continua em andamento no {{provider}} embora já devesse ter terminado, como uma ordem OTC que não fecha.",
  type_other: "Outra ocorrência",
  type_other_hint: "Qualquer outra coisa a revisar com {{provider}}.",
  resolution_beneficiary_credited: "O beneficiário recebeu o dinheiro",
  resolution_status_updated: "O provedor atualizou o status",
  resolution_other: "Outro motivo",
  case_strip_label: "Andamento da reclamação",
  case_step_pending_report: "Não reportada",
  case_step_reported: "Reportada",
  case_step_in_progress: "Em gestão",
  case_step_closed: "Encerrada",
  case_dismissed: "Descartada: não era uma ocorrência.",
  case_updated_today: "Teve movimento hoje.",
  case_quiet_one: "Sem novidades há 1 dia.",
  case_quiet_other: "Sem novidades há {{count}} dias.",
  case_stale: "{{count}} dias sem novidades: escreva de novo para {{provider}}.",
  panel_title: "Ocorrência com o provedor",
  panel_title_with_reference: "Ocorrência {{reference}}",
  panel_empty:
    "Se o cliente diz que este pagamento não chegou ou ficou travado, abra uma ocorrência para reportar a {{provider}} e acompanhar aqui.",
  panel_open: "Abrir ocorrência",
  panel_read_only: "Só quem pode carregar carteiras pode alterar uma ocorrência.",
  panel_opened_by: "aberta por {{email}}",
  panel_at_stake: "Em jogo",
  panel_case_reference: "Protocolo de {{provider}}",
  panel_client_refund: "Reembolso ao cliente",
  panel_copy_report: "Copiar relatório para {{provider}}",
  panel_copy_follow_up: "Copiar acompanhamento para {{provider}}",
  panel_record: "Registrar",
  panel_refund: "Reembolsar o cliente",
  panel_reading_provider: "Consultando {{provider}} para montar o relatório…",
  timeline_title: "Linha do tempo",
  timeline_label: "Linha do tempo da ocorrência",
  record_provider_responded: "{{provider}} respondeu",
  record_provider_refunded: "{{provider}} devolveu o dinheiro",
  record_resolved: "Encerrar a ocorrência",
  record_dismissed: "Descartar",
  record_note: "Adicionar nota ou imagens",
  record_reopened: "Reabrir",
  refund_blocked_payout_not_paid:
    "Não é possível reembolsar: o pagamento não consta como pago. Se falhou ou foi cancelado, o dinheiro já voltou; se continua em andamento, ainda pode chegar.",
  refund_blocked_incident_closed: "Reabra a ocorrência para reembolsar.",
  refund_blocked_wallet_not_found: "A organização não tem mais a carteira de onde o pagamento saiu.",
  refund_blocked_already_refunded: "O cliente já foi reembolsado.",
  event_opened: "Ocorrência aberta",
  event_report_copied: "Relatório copiado para {{provider}}",
  event_report_copied_follow_up: "Acompanhamento copiado para {{provider}}",
  event_provider_responded: "{{provider}} respondeu",
  event_provider_refunded: "{{provider}} devolveu o dinheiro",
  event_note: "Nota",
  event_resolved: "Ocorrência encerrada",
  event_dismissed: "Ocorrência descartada",
  event_reopened: "Ocorrência reaberta",
  event_client_refunded: "Reembolso ao cliente",
  event_two_factor: "com 2FA",
  event_two_factor_hint: "Confirmado com o segundo fator de quem fez.",
  event_recorded_on: "registrado em {{date}}",
  event_case_reference: "Protocolo: {{reference}}",
  event_attachments: "Anexos",
  event_attachment_open: "Abrir {{name}}",
  event_attachment_unavailable: "Indisponível",
  open_title: "Abrir ocorrência",
  open_description:
    "Fica registrada com o seu e-mail. Depois você copia o relatório para {{provider}} e acompanha o caso aqui.",
  open_field_type: "Tipo de ocorrência",
  open_field_description: "O que aconteceu",
  open_field_description_hint:
    "Vai como está no relatório para {{provider}}: conte o que o cliente ou o comércio viu.",
  open_field_description_placeholder:
    "A maquininha mostrou «Venda não realizada» e o comércio não recebeu o dinheiro; o cliente pagou de novo com cartão.",
  open_validation_description: "Conte o que aconteceu.",
  open_only: "Só abrir",
  open_and_report: "Abrir e copiar relatório",
  open_error: "Não conseguimos abrir a ocorrência. Tente de novo.",
  open_already_exists: "Este pagamento já tinha uma ocorrência: aqui está.",
  report_title: "Relatório para {{provider}}",
  report_description: "Cole no canal de suporte de {{provider}}. A cópia ficou na linha do tempo.",
  report_copy: "Copiar",
  report_copy_again: "Copiar de novo",
  report_copied: "Copiado",
  report_copied_toast: "Relatório copiado",
  report_copy_error: "Não foi possível copiar. Selecione o texto e copie manualmente.",
  report_auto_copied: "Já está na sua área de transferência: cole no canal de {{provider}}.",
  report_copy_hint: "Use «Copiar» e cole no canal de {{provider}}.",
  report_text_label: "Texto do relatório",
  report_evidence_stored:
    "Não conseguimos consultar {{provider}} agora: os dados vêm do que guardamos. Confira se estão completos antes de enviar.",
  report_evidence_none:
    "Não encontramos dados de {{provider}} para este pagamento: o relatório leva só os nossos.",
  report_two_factor_required: "Para copiar o relatório você precisa ativar a verificação em duas etapas.",
  report_two_factor_description:
    "Copiar o relatório para {{provider}} fica registrado com o seu segundo fator.",
  event_dialog_title_provider_responded: "{{provider}} respondeu",
  event_dialog_description_provider_responded: "Registre o que responderam e, se deram, o protocolo do caso.",
  event_dialog_confirm_provider_responded: "Salvar resposta",
  event_note_placeholder_provider_responded:
    "Escalaram com o Banrep e a ACH; não há prazo de resposta definido.",
  event_saved_provider_responded: "Resposta registrada",
  event_dialog_title_provider_refunded: "{{provider}} devolveu o dinheiro",
  event_dialog_description_provider_refunded:
    "Marque a ocorrência como devolvida por {{provider}}. Ela é encerrada.",
  event_dialog_confirm_provider_refunded: "Marcar devolvido",
  event_note_placeholder_provider_refunded: "A devolução chegou à carteira em …",
  event_saved_provider_refunded: "Devolução registrada",
  event_dialog_title_resolved: "Encerrar a ocorrência",
  event_dialog_description_resolved:
    "Encerre quando não restar nada pendente com {{provider}}. Pode ser reaberta.",
  event_dialog_confirm_resolved: "Encerrar ocorrência",
  event_note_placeholder_resolved: "A entidade confirmou que o crédito foi aplicado.",
  event_saved_resolved: "Ocorrência encerrada",
  event_dialog_title_dismissed: "Descartar a ocorrência",
  event_dialog_description_dismissed: "Para quando não era uma ocorrência. Pode ser reaberta.",
  event_dialog_confirm_dismissed: "Descartar",
  event_note_placeholder_dismissed: "O cliente indicou o pagamento errado.",
  event_saved_dismissed: "Ocorrência descartada",
  event_dialog_title_note: "Adicionar nota ou imagens",
  event_dialog_description_note: "Um acompanhamento na linha do tempo: o que você fez ou o que disseram.",
  event_dialog_confirm_note: "Salvar",
  event_note_placeholder_note: "Escrevi de novo pelo canal.",
  event_saved_note: "Nota salva",
  event_dialog_title_reopened: "Reabrir a ocorrência",
  event_dialog_description_reopened: "Volta à última etapa aberta que teve.",
  event_dialog_confirm_reopened: "Reabrir",
  event_note_placeholder_reopened: "O cliente reportou de novo.",
  event_saved_reopened: "Ocorrência reaberta",
  event_field_resolution: "Por que é encerrada",
  event_field_case_reference: "Protocolo",
  event_field_case_reference_hint: "O número do caso que {{provider}} deu, se deu.",
  event_field_day: "Quando aconteceu",
  event_field_day_hint: "Se foi outro dia, informe: a linha do tempo é ordenada por essa data.",
  event_field_answer: "O que responderam",
  event_field_note: "Nota",
  event_field_attachments: "Imagens ou documentos",
  event_validation_note: "Escreva uma nota ou anexe um arquivo.",
  event_error: "Não conseguimos salvar. Tente de novo.",
  event_provider_refunded_info:
    "Isto não move dinheiro na Coloca: a devolução entra na carteira de {{provider}} e aparece em «Saldos nos provedores». Se o cliente ainda não foi reembolsado, faça depois com «Reembolsar o cliente».",
  event_provider_refunded_info_refunded:
    "Isto não move dinheiro na Coloca: a devolução entra na carteira de {{provider}} e recupera o que a Coloca já reembolsou ao cliente.",
  event_resolved_refunded_warning:
    "O cliente já foi reembolsado. Se o beneficiário recebeu o pagamento, o cliente ficou com o dinheiro duas vezes e é preciso recuperá-lo manualmente.",
  attachments_add: "Anexar",
  attachments_hint: "Até {{max}} imagens ou PDFs de {{size}} MB.",
  attachments_remove: "Remover {{name}}",
  attachments_rejected_too_many: "Só cabem {{max}} arquivos por entrada.",
  attachments_rejected_too_large: "{{name}} tem mais de {{size}} MB.",
  attachments_rejected_unsupported_type: "{{name}} não é uma imagem nem um PDF.",
  refund_title: "Reembolsar o cliente",
  refund_title_review: "Revise o reembolso",
  refund_title_done: "Reembolso creditado",
  refund_description: "Você devolve o pagamento a {{organization}} enquanto {{provider}} resolve.",
  refund_description_done: "O cliente já tem o dinheiro na carteira e recebe o comprovante.",
  refund_field_amount: "Valor a reembolsar",
  refund_field_amount_hint:
    "Por padrão, tudo o que foi cobrado: {{max}} {{currency}}. Você pode diminuir, não aumentar.",
  refund_field_note: "Nota interna",
  refund_field_note_hint: "Opcional. Vai para a nota interna e a linha do tempo; o cliente não vê.",
  refund_review: "Revisar reembolso",
  refund_review_organization: "Organização",
  refund_review_wallet: "Carteira",
  refund_review_wallet_value: "Carteira {{currency}}",
  refund_review_charged: "O que foi cobrado por esse pagamento",
  refund_review_amount: "Reembolso",
  refund_review_client_sees:
    "O cliente vê na carteira como «Reembolso da Coloca Payments», com o pagamento reembolsado no conceito, e recebe o comprovante por e-mail.",
  refund_review_coloca_money:
    "É dinheiro da Coloca até que {{provider}} devolva os fundos. Não pode ser desfeito daqui.",
  refund_review_checkbox: "Revisei o valor e a organização.",
  refund_confirm: "Reembolsar",
  refund_transit_aria: "A Coloca credita {{amount}} {{currency}} a {{name}}",
  refund_transit_from: "Coloca Payments",
  refund_error_already: "Esta ocorrência já tem um reembolso. Atualizamos a visualização.",
  refund_validation_invalid: "Digite um valor válido.",
  refund_validation_not_positive: "O valor deve ser maior que zero.",
  refund_validation_precision: "{{currency}} aceita até {{digits}} casas decimais.",
  refund_validation_exceeds: "Não pode superar o que foi cobrado: {{max}} {{currency}}.",
  refund_two_factor_required: "Para reembolsar você precisa ativar a verificação em duas etapas.",
  refund_two_factor_description: "O reembolso move dinheiro da Coloca: confirme com o seu segundo fator.",
  summary_open: "Ocorrências abertas",
  summary_open_meta: "{{pending}} não reportadas · {{waiting}} aguardando resposta",
  summary_stale: "Sem novidades há 7 dias ou mais",
  summary_stale_meta: "Hora de escrever de novo ao provedor",
  summary_at_stake: "Em jogo",
  summary_advanced: "Adiantado pela Coloca",
  summary_error: "Não conseguimos carregar o resumo das ocorrências.",
  summary_outdated:
    "Não conseguimos atualizar o resumo. Estes números são de {{time}} e podem estar desatualizados.",
  summary_advanced_meta: "Reembolsado a clientes, sem devolução do provedor ainda",
  filter_open: "Abertas",
  filter_any: "Com ocorrência",
  filter_none: "Sem ocorrência",
  filter_pending_report: "Não reportadas",
  filter_reported: "Reportadas, sem resposta",
  filter_in_progress: "Em gestão",
  filter_provider_refunded: "Devolvidas pelo provedor",
  filter_resolved: "Encerradas",
  filter_dismissed: "Descartadas",
  movements_days_quiet_one: "1 dia sem novidades",
  movements_days_quiet_other: "{{count}} dias sem novidades",
  movements_client_refunded: "cliente reembolsado",
};
